// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-5c117e63] .swiper-pagination-bullet{background:#fff;border-radius:50%;box-shadow:0 0 0 4px hsla(0,0%,100%,.3);cursor:pointer;height:8px;opacity:1;transition:all .3s ease;width:8px}[data-v-5c117e63] .swiper-pagination-bullet-active{background:#fff;box-shadow:0 0 0 4px #ff123f;transform:scale(1.2)}[data-v-5c117e63] .swiper-pagination-bullet:hover{background:hsla(0,0%,100%,.5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
